export default __webpack_public_path__ + "static/media/doc.3b155c14.svg";